module.exports = __webpack_public_path__ + "img/Total Security Summit.10e6edcd.png";